import { RosterContent } from '../../types/roster-content';

export abstract class RosterEventRepository<T extends RosterContent, TDetail = unknown> {
  abstract loadEvents(
    employeeId: number,
    begintime: string,
    endtime: string,
    employeeIdPerson: number | string
  ): Promise<T[]>;
  abstract loadEventDetail(
    employeeId: number,
    eventId: string | number
  ): Promise<TDetail>;
  abstract createEvent(payload: Partial<T>): Promise<T>;
  abstract updateEvent(event: T): Promise<T>;
  abstract deleteEvent(event: T): Promise<T>;
  abstract deleteEvents(events: T[]): Promise<T[]>;
  abstract delete(id: number): Promise<void>;
}
